<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
    >
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table
      ref="table"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :btns="btns"
      :allBtnWidth="allBtnWidth"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
      <template slot="isdisplay" slot-scope="params">
        <MySwitch
          :data="params.params"
          :disabled="canNotHide.includes(params.params.gasname)"
          :activeValue="'1'"
          :inactiveValue="`2`"
          @onToggle="toggleDisplay"
        ></MySwitch>
      </template>
    </Table>

    <FormDialog
      ref="dialog"
      :title="title"
      :width="'548px'"
      :form="mform"
      :formCtrl="mformCtrl"
      :rules="mrules"
      :viewMode="viewMode"
      @onModalSubmit="onModalSubmit"
    ></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "gasstationconfigure",
      breadcrumb: [{ name: "系统设置" }, { name: "油气站配置" }],
      formCtrl: [
        {
          label: "",
          keyName: "gasname",
          placeholder: "请填写加油站名称",
          type: "text",
        },
      ],
      cols: [
        { prop: "gasname", label: "加油站名称" },
        { prop: "isdisplay", label: "是否显示", slot: "isdisplay" },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // console.log(data)
            this.getItem(data);
            this.showDialog();
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
      title: "添加",
      viewMode: false,
      mform: { gasname: undefined },
      mrules: {
        gasname: [
          {
            required: true,
            message: "请填写加油站名称",
            trigger: "blur",
          },
        ],
      },
      mformCtrl: [
        {
          label: "加油站名称",
          keyName: "gasname",
          err: "请填写加油站名称",
          type: "text",
        },
      ],
      canNotHide: ["现金加油"],
      canNotEdit: ["现金加油"],
    };
  },
  methods: {
    // tableDataHandler({ count, data }) {
    //   this.total = count
    //   if (data && data.length) {
    //     this.tableData = data.map(v => {
    //       const obj = { ...v }
    //       obj.open = v.isdisplay + ''
    //       return obj
    //     })
    //   }
    //   // console.log(this.tableData)
    // },
    tableDataHandler({ count, data }) {
      this.total = count;
      if (data && data.length) {
        this.tableData = data.map((v) => {
          const obj = { ...v };
          obj.open = v.isdisplay + "";
          obj.DISABLED = this.canNotEdit.includes(obj.gasname);
          return obj;
        });
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      console.log(id);
      let url = `${this.baseUrl}/upstatus `;
      const params = {
        userid: this.user.id,
        id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.getList(true);
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },
    add() {
      delete this.mform.id;
      this.mform = { gasname: undefined };
      this.title = "添加";
      this.showDialog();
    },
    getItem({ id, gasname }) {
      this.mform = { ...this.mform, id, gasname };
      this.title = "修改";
    },
    onModalSubmit(data) {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      this.loading = true;
      let url = `${this.baseUrl}/addedu`;
      const params = {
        ...data,
        userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  .el-dialog__body {
    padding: 30px 0 0 0;
  }
}
</style>
